import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { Storage } from "@faire/web--source/common/Storage";
// used for development via extension plugin - allows for tracking of settings
export var ENABLE_SETTING_XP_LOGGING = "ENABLE_SETTING_XP_LOGGING";
export var SETTINGS_AND_XP_TRACKED = "SETTINGS_AND_XP_TRACKED";
export var isLoggingSettingUsageEnabled = function() {
    return Storage.local.getItem(ENABLE_SETTING_XP_LOGGING);
};
export var trackSettingsAndExperiment = function(settingNames, options) {
    var _getWindow;
    var _getWindow_location_pathname;
    var pathName = (_getWindow_location_pathname = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.location.pathname) !== null && _getWindow_location_pathname !== void 0 ? _getWindow_location_pathname : "path_undefined";
    var currentValues = JSON.parse(Storage.local.getItem(SETTINGS_AND_XP_TRACKED) || "{}");
    var settingValue = options.settingValue, isAssignment = options.isAssignment;
    var _currentValues_pathName;
    var valuesOnCurrentPage = (_currentValues_pathName = currentValues[pathName]) !== null && _currentValues_pathName !== void 0 ? _currentValues_pathName : {
        assignments: {},
        settings: {}
    };
    settingNames.forEach(function(settingName) {
        if (isAssignment) {
            valuesOnCurrentPage["assignments"][settingName] = true;
        } else {
            valuesOnCurrentPage["settings"][settingName] = settingValue;
        }
    });
    currentValues[pathName] = valuesOnCurrentPage;
    Storage.local.setItem(SETTINGS_AND_XP_TRACKED, JSON.stringify(currentValues));
};
